import React from "react";
import AppBaseComponent from "../../components/AppBaseComponent";
import TapSelect from "../../components/ui/TapSelect";
import { connect } from "react-redux";
import uuid from "react-uuid";
import { Modal } from "bootstrap";
import tapIcon from "../../services/TapIcon";
import moment from "moment";
import { Link } from "react-router-dom/cjs/react-router-dom.min";
import Ax from "../../components/hoc/Ax";
import { Helmet } from 'react-helmet';
import CommonExpenseAddForm from "./CommonExpenseAddForm";

class ExpenseAddModal extends AppBaseComponent {
  constructor(props) {
    super(props);

    this.expenseAddFormLabel        =   {};

    this.state                      =   {
      modalData                         :   { ticetId: null, assetName: null, assetType: null },
      userSite                          :   [],
       editExpenseTicketData                  :   null
    };

    this.expenseModalId                 =   uuid();
  }

    componentDidMount() {
        this.expenseModalInit       =   new Modal(document.getElementById(this.expenseModalId), { keyboard: false, backdrop: false });
    }

  expenseModalShow              = (type = null, data = {},editExpenseTicketData=null) => {
   
    this.setState({
        userSite                    :   this.props.iam_user_sites ? this.props.iam_user_sites.map((s) => { return { value: s.id, label: `${s.site_name} (${s.site_code})` };}): [],
        modalData                   :   { ...this.state.modalData, ...data },
        editExpenseTicketData                    :   editExpenseTicketData, 
      },() => {
        this.expenseModalInit.show();
    });
    };
    

    expenseAddModalJsx = () => {
        
        return (
            <div className="modal fade" id={this.expenseModalId} tabIndex="-1">
                <div className="modal-dialog modal-lg">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title" id="expenseAddModalLabel"> {this.state.editExpenseTicketData ? "Edit" : "Add"} Expense</h5>
                            <button type="button" className="btn-close" onClick={() => this.expenseModalInit.hide()}></button>
                        </div>
                        <div className="row mx-2 mt-2">
                            <table className="table table-sm mb-0 table-borderless text-sm">
                                <tbody>
                                    <tr>
                                        <td style={{ width: "25%" }}>&nbsp;&nbsp;Ticket ID</td>
                                        <th>{this.state.modalData.ticetId !== null ? this.state.modalData.ticetId : ""}</th>
                                    </tr>
                                    {this.state.modalData && this.state.modalData.assetName && <Ax>
                                        <tr>
                                            <td style={{ width: "25%" }}>&nbsp;&nbsp;Asset Name (Code)</td>
                                            <th>{this.state.modalData.assetName}</th>
                                        </tr>
                                        <tr>
                                            <td>&nbsp;&nbsp;Asset Type</td>
                                            <th>{this.state.modalData.assetType}</th>
                                        </tr>
                                    </Ax>}
                                    <tr>
                                        <td>&nbsp;&nbsp;Site Name</td>
                                        <th>{this.state.modalData.siteName}</th>
                                    </tr>
                                </tbody>
                            </table>
                           
                        </div>
                        <hr />

                        <div className="modal-body">
                            <CommonExpenseAddForm
                                showModalData={true}
                                 expenseForData={this.state.modalData.expenseForData}
                                ticketId={this.state.modalData.ticetId}
                                editExpenseTicketData={this.state.editExpenseTicketData}
                                onSuccess={() => {
                                    this.props.afterSubmitFormModal(this.state.modalData.ticetId);
                                    this.props.ticketDetail();
                                    this.expenseModalInit.hide();
                                }}
                            />
                        </div>

                    </div>
                </div>
            </div>
        );
    };



  render = () => {
        return <Ax>
            {this.expenseAddModalJsx()}
        </Ax>;
    };
}

const mapStateToProps           =   (state) =>  {
  return {
    access_token            :   state.auth.access_token,
    // all_periods             :   state.app && state.app.all_periods ? state.app.all_periods : [],
    // iam_asset_types         :   state.app && state.app.asset_type ? state.app.asset_type : [],
    iam_user_sites          :   state.app && state.app.user_sites ? state.app.user_sites : [],
  };
};

export default connect(mapStateToProps, null, null, { forwardRef: true })(ExpenseAddModal);     
